import { createSlice } from "@reduxjs/toolkit";

const subMenuClickSlice = createSlice({
  name: "subMenuClick",
  initialState: false,
  reducers: {
    setSubMenuClick: (state, action) => {
      return action.payload;
    },
  },
});

export const { setSubMenuClick } = subMenuClickSlice.actions;
export default subMenuClickSlice.reducer;
